import { FC } from 'react';

import { UlStyled } from './PrinterKnowledgeBase.styles';

export const PrinterKnowledgeBase: FC = () => (
	<UlStyled>
		<li>
			<a
				href='https://dodopizza.info/articles/b3b7cc1e-a5ec-4e32-87ea-0d7eaac5436c'
				target='_blank'
				rel='noreferrer'
			>
				{`Оборудование: принтер этикеток упаковки `}
			</a>
		</li>
		<li>
			<a
				href='https://dodopizza.info/support/articles/83de2b82-b4c9-45f5-c366-08d81c4ca2b8'
				target='_blank'
				rel='noreferrer'
			>
				Как установить принтер упаковки и принтер маркировки
			</a>
		</li>
		<li>
			<a
				href='https://dodopizza.info/standards/980c2ed7-4798-419e-b274-c35db3b0f675'
				target='_blank'
				rel='noreferrer'
			>
				Стандарт маркировки продуктов
			</a>
		</li>
	</UlStyled>
);
